<template>
  <div
    class="nodes__tree"
    v-for="(node, index) in nodes"
    :key="node.id"
    :class="{
      'tree-connection-siblings': node.node && index !== nodes.length - 1,
      siblings: nodes.length > 1 ? nodes[index].node_order < nodes.length : false,
    }"
  >
    <div :class="{ 'tree-connection': node.node }">
      <NodeCard
        :node="node"
        :nodes="nodes"
        :sequence="sequence"
        :id="`sequence-node-${index}`"
        :parent-node="parentNode"
        @click="handleOpenDrawer"
        @delete="(ids) => emit('closeSettings', ids)"
        @update="handleUpdate"
      />
    </div>

    <div class="child__nodes__tree">
      <NodesTree
        v-if="node.child"
        :sequence="sequence"
        :nodes="node.child"
        :parent-node="node"
        @update="handleUpdate"
        @openSettings="handleOpenDrawer"
        @closeSettings="(ids) => emit('closeSettings', ids)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Sequence, SequenceNode } from "@/@types/flows/sequences";

import NodeCard from "@/app/flows/sequences/components/nodes/NodeCard.vue";

// import NodeCard from "@/app/ivr/bot/components/cards/NodeCard.vue";

defineProps<{
  sequence: Sequence;
  nodes: SequenceNode[];
  parentNode: SequenceNode | undefined;
}>();

const emit = defineEmits<{
  openSettings: [node: SequenceNode];
  closeSettings: [ids: number[]];
  update: [];
}>();

const handleUpdate = () => {
  emit("update");
};

const handleOpenDrawer = (node: SequenceNode) => emit("openSettings", node);
</script>

<style scoped lang="sass">
.nodes__tree
  &.siblings::after
    content: ""
    display: block
    position: absolute
    width: 16px
    margin-left: 16px
    // height: 62%
    height: 8px
    // border-bottom-left-radius: 6px
    border-left: 2px solid $blue-3
    // border-bottom: 1px solid $blue-3
    margin-top: -8px
    // bottom: 50%
    pointer-events: none
    transform: translateZ(0)
    background: transparent

.child__nodes__tree
  margin-left: 32px

.tree-connection
  position: relative

  &::before
    content: ""
    display: block
    position: absolute
    width: 16px
    margin-left: -16px
    height: 62%
    border-bottom-left-radius: 6px
    border-left: 1px solid $blue-3
    border-bottom: 1px solid $blue-3
    margin-top: -8px
    bottom: 50%
    pointer-events: none
    transform: translateZ(0)
    background: transparent

.tree-connection-siblings
  position: relative

  &::before
    content: ""
    display: block
    position: absolute
    width: 16px
    height: calc(100% + 20px)
    // border-bottom-left-radius: 6px
    border-left: 1px solid $blue-3
    // border-bottom: 1px solid $gray-7
    margin-left: -16px
    margin-top: -8px
    pointer-events: none
    transform: translateZ(0)
    background: transparent
</style>
